var __create = Object.create;
var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties,
  __getOwnPropDesc = Object.getOwnPropertyDescriptor,
  __getOwnPropDescs = Object.getOwnPropertyDescriptors,
  __getOwnPropNames = Object.getOwnPropertyNames,
  __getOwnPropSymbols = Object.getOwnPropertySymbols,
  __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from[key],
    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_isObjectLike = __commonJS({
  "../../../../node_modules/lodash/isObjectLike.js"(exports, module) {
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});
var require_freeGlobal = __commonJS({
  "../../../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});
var require_root = __commonJS({
  "../../../../node_modules/lodash/_root.js"(exports, module) {
    var freeGlobal = require_freeGlobal(),
      freeSelf = typeof self == "object" && self && self.Object === Object && self,
      root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});
var require_Symbol = __commonJS({
  "../../../../node_modules/lodash/_Symbol.js"(exports, module) {
    var root = require_root(),
      Symbol = root.Symbol;
    module.exports = Symbol;
  }
});
var require_getRawTag = __commonJS({
  "../../../../node_modules/lodash/_getRawTag.js"(exports, module) {
    var Symbol = require_Symbol(),
      objectProto = Object.prototype,
      hasOwnProperty = objectProto.hasOwnProperty,
      nativeObjectToString = objectProto.toString,
      symToStringTag = Symbol ? Symbol.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = !0;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      return unmasked && (isOwn ? value[symToStringTag] = tag : delete value[symToStringTag]), result;
    }
    module.exports = getRawTag;
  }
});
var require_objectToString = __commonJS({
  "../../../../node_modules/lodash/_objectToString.js"(exports, module) {
    var objectProto = Object.prototype,
      nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});
var require_baseGetTag = __commonJS({
  "../../../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    var Symbol = require_Symbol(),
      getRawTag = require_getRawTag(),
      objectToString = require_objectToString(),
      nullTag = "[object Null]",
      undefinedTag = "[object Undefined]",
      symToStringTag = Symbol ? Symbol.toStringTag : void 0;
    function baseGetTag(value) {
      return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});
var require_overArg = __commonJS({
  "../../../../node_modules/lodash/_overArg.js"(exports, module) {
    function overArg(func4, transform) {
      return function (arg) {
        return func4(transform(arg));
      };
    }
    module.exports = overArg;
  }
});
var require_getPrototype = __commonJS({
  "../../../../node_modules/lodash/_getPrototype.js"(exports, module) {
    var overArg = require_overArg(),
      getPrototype = overArg(Object.getPrototypeOf, Object);
    module.exports = getPrototype;
  }
});
var require_isPlainObject = __commonJS({
  "../../../../node_modules/lodash/isPlainObject.js"(exports, module) {
    var baseGetTag = require_baseGetTag(),
      getPrototype = require_getPrototype(),
      isObjectLike = require_isObjectLike(),
      objectTag = "[object Object]",
      funcProto = Function.prototype,
      objectProto = Object.prototype,
      funcToString = funcProto.toString,
      hasOwnProperty = objectProto.hasOwnProperty,
      objectCtorString = funcToString.call(Object);
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) return !1;
      var proto = getPrototype(value);
      if (proto === null) return !0;
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    module.exports = isPlainObject;
  }
});
var require_isElement = __commonJS({
  "../../../../node_modules/lodash/isElement.js"(exports, module) {
    var isObjectLike = require_isObjectLike(),
      isPlainObject = require_isPlainObject();
    function isElement2(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }
    module.exports = isElement2;
  }
});
import * as React2 from "react";
import * as PropTypes from "prop-types";
import { useUID } from "@twilio-paste/uid-library";
import { useCompositeState, Composite } from "@twilio-paste/reakit-library";
import { Table } from "@twilio-paste/table";
import * as React from "react";
var DataGridContext = React.createContext({
  actionable: !1,
  striped: !1
});
function matches(element, selectors) {
  return "matches" in element ? element.matches(selectors) : "msMatchesSelector" in element ? element.msMatchesSelector(selectors) : element.webkitMatchesSelector(selectors);
}
var selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function isFocusable(element) {
  return matches(element, selector);
}
function getAllFocusableIn(container) {
  return Array.from(container.querySelectorAll(selector)).filter(isFocusable);
}
function getFirstFocusableIn(container) {
  let [first] = getAllFocusableIn(container);
  return first || null;
}
function getDocument(element) {
  return element ? element.ownerDocument || element : document;
}
function getActiveElement(element) {
  let {
    activeElement
  } = getDocument(element);
  return activeElement != null && activeElement.nodeName ? activeElement : null;
}
function hasFocus(element) {
  let activeElement = getActiveElement(element);
  if (!activeElement) return !1;
  if (activeElement === element) return !0;
  let activeDescendant = activeElement.getAttribute("aria-activedescendant");
  return activeDescendant ? activeDescendant === element.id : !1;
}
function ensureFocus(element) {
  let {
    preventScroll,
    isActive = hasFocus
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return isActive(element) || (element.focus({
    preventScroll
  }), isActive(element)) ? -1 : requestAnimationFrame(() => {
    element.focus({
      preventScroll
    });
  });
}
var updateTabIndexForActionable = (cellElement, actionable) => {
    getAllFocusableIn(cellElement).forEach(element => {
      element.tabIndex = actionable ? 0 : -1;
    });
  },
  delayedSetFocusable = element => {
    setTimeout(() => {
      element != null && (element.tabIndex = 0);
    }, 150);
  },
  isCell = element => element.tagName === "TD" || element.tagName === "TH",
  getClosestCellFrom = (element, dataGridId) => element == null || !dataGridId ? null : element.closest(`#${dataGridId} th, #${dataGridId} td`),
  getClosestGridCellFromCurrentFocus = dataGridId => {
    let focusedElement = getActiveElement();
    return focusedElement ? isCell(focusedElement) ? focusedElement : getClosestCellFrom(focusedElement, dataGridId) : null;
  };
var DataGrid = React2.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "DATA_GRID",
      striped = !1
    } = _b,
    props = __objRest(_b, ["element", "striped"]);
  let dataGridId = `data-grid-${useUID()}`,
    lastFocusedElement = React2.useRef(null),
    compositeState = useCompositeState({
      unstable_virtual: !1
    }),
    [actionable, setActionable] = React2.useState(!1),
    handleMouseDown = React2.useCallback(() => {
      setActionable(!0);
    }, []),
    handleFocus = React2.useCallback(e => {
      e.target != null && (lastFocusedElement.current = e.target);
    }, []),
    handleBlur = React2.useCallback(event => {
      if (!event.currentTarget.contains(event.relatedTarget) && (setActionable(!1), lastFocusedElement.current != null)) {
        let closestCell = getClosestCellFrom(lastFocusedElement.current, dataGridId);
        closestCell && delayedSetFocusable(closestCell);
      }
    }, [dataGridId]),
    handleKeypress = React2.useCallback(event => {
      switch (event.key) {
        case "Enter":
          {
            setActionable(!0);
            let activeElement = getActiveElement();
            if (isCell(activeElement)) {
              let firstFocusableElement = getFirstFocusableIn(activeElement);
              firstFocusableElement && (ensureFocus(firstFocusableElement), activeElement.tabIndex = actionable ? 0 : -1);
            }
            break;
          }
        case "Escape":
          {
            setActionable(!1);
            let closestCell = getClosestGridCellFromCurrentFocus(dataGridId);
            closestCell && (ensureFocus(closestCell), delayedSetFocusable(closestCell));
            break;
          }
        default:
          break;
      }
    }, [actionable, dataGridId]),
    dataGridState = __spreadProps(__spreadValues({}, compositeState), {
      actionable,
      striped
    });
  return React2.createElement(DataGridContext.Provider, {
    value: dataGridState
  }, React2.createElement(Composite, __spreadProps(__spreadValues(__spreadValues({}, props), compositeState), {
    id: dataGridId,
    ref,
    as: Table,
    element,
    role: "grid",
    onKeyDown: handleKeypress,
    onMouseDown: handleMouseDown,
    onFocus: handleFocus,
    onBlur: handleBlur,
    isActionable: actionable,
    "data-actionable": actionable
  })));
});
DataGrid.displayName = "DataGrid";
DataGrid.propTypes = {
  "aria-label": PropTypes.string.isRequired,
  element: PropTypes.string
};
import * as React3 from "react";
import * as PropTypes2 from "prop-types";
import { THead } from "@twilio-paste/table";
var DataGridHead = React3.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "DATA_GRID_HEAD"
    } = _b,
    props = __objRest(_b, ["element"]);
  return React3.createElement(THead, __spreadProps(__spreadValues({}, props), {
    element,
    ref
  }));
});
DataGridHead.displayName = "DataGridHead";
DataGridHead.propTypes = {
  element: PropTypes2.string
};
import * as React5 from "react";
import * as PropTypes4 from "prop-types";
import { CompositeGroup } from "@twilio-paste/reakit-library";
import * as React4 from "react";
import * as PropTypes3 from "prop-types";
import { styled, css } from "@twilio-paste/styling-library";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
var StyledTr = styled.tr(css({
    "&[aria-selected=true] > td": {
      borderColor: "colorBorderWeak"
    },
    "&[aria-selected=true] > th": {
      borderColor: "colorBorderWeak"
    }
  })),
  Tr = React4.forwardRef((_a, ref) => {
    var _b = _a,
      {
        element = "DATA_GRID_TR",
        striped
      } = _b,
      props = __objRest(_b, ["element", "striped"]);
    return React4.createElement(Box, __spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
      ref,
      element,
      as: StyledTr,
      "aria-selected": props.selected,
      _even: {
        backgroundColor: striped ? "colorBackgroundRowStriped" : "transparent"
      },
      _last: {
        borderWidth: "borderWidth0"
      },
      _selected: {
        backgroundColor: "colorBackgroundPrimaryWeakest"
      }
    }));
  });
Tr.displayName = "Tr";
Tr.propTypes = {
  role: PropTypes3.string.isRequired,
  selected: PropTypes3.bool,
  element: PropTypes3.string
};
var DataGridRow = React5.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "DATA_GRID_ROW"
    } = _b,
    props = __objRest(_b, ["element"]);
  let dataGridState = React5.useContext(DataGridContext);
  return React5.createElement(CompositeGroup, __spreadProps(__spreadValues(__spreadProps(__spreadValues({
    as: Tr
  }, props), {
    element
  }), dataGridState), {
    ref,
    role: "row"
  }));
});
DataGridRow.displayName = "DataGridRow";
DataGridRow.propTypes = {
  selected: PropTypes4.bool,
  element: PropTypes4.string
};
import * as React9 from "react";
import * as PropTypes8 from "prop-types";
import * as React8 from "react";
import * as PropTypes7 from "prop-types";
import { CompositeItem } from "@twilio-paste/reakit-library";
import { useMutationObservable } from "@twilio-paste/utils";
import * as React6 from "react";
import * as PropTypes5 from "prop-types";
import { Box as Box2, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
var Td = React6.forwardRef((_a, ref) => {
  var _b = _a,
    {
      textAlign = "left",
      element = "DATA_GRID_TD"
    } = _b,
    props = __objRest(_b, ["textAlign", "element"]);
  return React6.createElement(Box2, __spreadProps(__spreadValues({}, safelySpreadBoxProps2(props)), {
    ref,
    as: "td",
    element,
    borderStyle: "solid",
    borderColor: "colorBorderWeaker",
    borderWidth: "borderWidth0",
    borderBottomWidth: "borderWidth10",
    fontSize: "fontSize30",
    lineHeight: "lineHeight30",
    paddingY: "space40",
    paddingX: "space50",
    position: "relative",
    textAlign,
    verticalAlign: "inherit",
    wordWrap: "break-word",
    _first: {
      paddingLeft: "space50"
    },
    _last: {
      paddingRight: "space50"
    },
    _focus: {
      outline: "none",
      boxShadow: "shadowFocusInset"
    }
  }));
});
Td.displayName = "Td";
Td.propTypes = {
  onClick: PropTypes5.func,
  element: PropTypes5.string
};
import * as React7 from "react";
import * as PropTypes6 from "prop-types";
import { Box as Box3, safelySpreadBoxProps as safelySpreadBoxProps3 } from "@twilio-paste/box";
var Th = React7.forwardRef((_a, ref) => {
  var _b = _a,
    {
      width,
      textAlign = "left",
      element = "DATA_GRID_TH"
    } = _b,
    props = __objRest(_b, ["width", "textAlign", "element"]);
  return React7.createElement(Box3, __spreadProps(__spreadValues({}, safelySpreadBoxProps3(props)), {
    ref,
    element,
    as: "th",
    borderBottomStyle: "solid",
    borderBottomColor: "colorBorderWeaker",
    borderBottomWidth: "borderWidth10",
    fontSize: "fontSize30",
    lineHeight: "lineHeight30",
    fontWeight: "fontWeightSemibold",
    paddingY: "space40",
    paddingX: "space50",
    width,
    position: "relative",
    textAlign,
    verticalAlign: "inherit",
    _first: {
      paddingLeft: "space50"
    },
    _last: {
      paddingRight: "space50"
    },
    _focus: {
      outline: "none",
      boxShadow: "shadowFocusInset"
    }
  }));
});
Th.displayName = "Th";
Th.propTypes = {
  onClick: PropTypes6.func,
  width: PropTypes6.string,
  element: PropTypes6.string,
  colSpan: PropTypes6.number
};
var import_isElement = __toESM(require_isElement()),
  DataGridCell = _a => {
    var _b = _a,
      {
        element = "DATA_GRID_CELL",
        as = "td"
      } = _b,
      props = __objRest(_b, ["element", "as"]);
    let dataGridState = React8.useContext(DataGridContext),
      cellRef = React8.useRef(),
      handleMouseDown = React8.useCallback(() => {
        ensureFocus(cellRef.current);
      }, []),
      onListMutation = React8.useCallback(mutationList => {
        mutationList.length !== 0 && mutationList.forEach(mutation => {
          if (!(0, import_isElement.default)(mutation.target)) return;
          let target = mutation.target;
          mutation.attributeName === "tabindex" && dataGridState.actionable && target.tabIndex === 0 && isCell(target) && (target.tabIndex = -1);
        });
      }, [dataGridState.actionable]);
    return useMutationObservable(cellRef.current, onListMutation), React8.useEffect(() => {
      cellRef.current && updateTabIndexForActionable(cellRef.current, dataGridState.actionable);
    }, [dataGridState.actionable]), React8.createElement(CompositeItem, __spreadProps(__spreadValues(__spreadValues({}, props), dataGridState), {
      element,
      ref: cellRef,
      as: as === "td" ? Td : Th,
      onClick: handleMouseDown
    }));
  };
DataGridCell.displayName = "DataGridCell";
DataGridCell.propTypes = {
  as: PropTypes7.oneOf(["th", "td"]),
  element: PropTypes7.string,
  colSpan: PropTypes7.number
};
var DataGridHeader = _a => {
  var _b = _a,
    {
      element = "DATA_GRID_HEADER"
    } = _b,
    props = __objRest(_b, ["element"]);
  return React9.createElement(DataGridCell, __spreadProps(__spreadValues({
    element
  }, props), {
    as: "th"
  }));
};
DataGridHeader.displayName = "DataGridHeader";
DataGridHeader.propTypes = {
  element: PropTypes8.string,
  colSpan: PropTypes8.number
};
import * as React11 from "react";
import * as PropTypes10 from "prop-types";
import { Button } from "@twilio-paste/button";
import * as React10 from "react";
import { Box as Box4 } from "@twilio-paste/box";
var __defProp2 = Object.defineProperty,
  __defProps2 = Object.defineProperties,
  __getOwnPropDescs2 = Object.getOwnPropertyDescriptors,
  __getOwnPropSymbols2 = Object.getOwnPropertySymbols,
  __hasOwnProp2 = Object.prototype.hasOwnProperty,
  __propIsEnum2 = Object.prototype.propertyIsEnumerable,
  __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues2 = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp2.call(b, prop) && __defNormalProp2(a, prop, b[prop]);
    if (__getOwnPropSymbols2) for (var prop of __getOwnPropSymbols2(b)) __propIsEnum2.call(b, prop) && __defNormalProp2(a, prop, b[prop]);
    return a;
  },
  __spreadProps2 = (a, b) => __defProps2(a, __getOwnPropDescs2(b)),
  __objRest2 = (source, exclude) => {
    var target = {};
    for (var prop in source) __hasOwnProp2.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
    if (source != null && __getOwnPropSymbols2) for (var prop of __getOwnPropSymbols2(source)) exclude.indexOf(prop) < 0 && __propIsEnum2.call(source, prop) && (target[prop] = source[prop]);
    return target;
  },
  ScreenReaderOnly = React10.forwardRef((_a, ref) => {
    var _b = _a,
      {
        as = "span",
        children
      } = _b,
      props = __objRest2(_b, ["as", "children"]);
    return React10.createElement(Box4, __spreadProps2(__spreadValues2({}, props), {
      as,
      border: "none",
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "spaceNegative10",
      overflow: "hidden",
      padding: "space0",
      position: "absolute",
      ref,
      textTransform: "none",
      whiteSpace: "nowrap",
      width: "1px"
    }), children);
  });
ScreenReaderOnly.displayName = "ScreenReaderOnly";
import { ArrowDownIcon } from "@twilio-paste/icons/esm/ArrowDownIcon";
import { ArrowUpIcon } from "@twilio-paste/icons/esm/ArrowUpIcon";
import { UnsortedIcon } from "@twilio-paste/icons/esm/UnsortedIcon";
var DataGridHeaderSortIcon = _ref => {
    let {
      direction,
      element
    } = _ref;
    switch (direction) {
      case "ascending":
        return React11.createElement(ArrowUpIcon, {
          decorative: !0,
          element
        });
      case "descending":
        return React11.createElement(ArrowDownIcon, {
          decorative: !0,
          element
        });
      case "none":
        return React11.createElement(UnsortedIcon, {
          decorative: !0,
          element
        });
      default:
        return null;
    }
  },
  DataGridHeaderSort = _a => {
    var _b = _a,
      {
        direction,
        onClick,
        element = "DATA_GRID_HEADER_SORT",
        i18nAscendingLabel = "Sort ascending",
        i18nDescendingLabel = "Sort descending",
        i18nUnsortedLabel = "Unsorted"
      } = _b,
      props = __objRest(_b, ["direction", "onClick", "element", "i18nAscendingLabel", "i18nDescendingLabel", "i18nUnsortedLabel"]);
    let i18nLabelDirectionMap = {
      ascending: i18nAscendingLabel,
      descending: i18nDescendingLabel,
      none: i18nUnsortedLabel
    };
    return React11.createElement(Button, __spreadValues({
      element,
      variant: "reset",
      size: "reset",
      onClick
    }, props), React11.createElement(DataGridHeaderSortIcon, {
      element: `${element}_ICON`,
      direction
    }), React11.createElement(ScreenReaderOnly, null, i18nLabelDirectionMap[direction]));
  };
DataGridHeaderSort.displayName = "DataGridHeaderSort";
DataGridHeaderSort.propTypes = {
  direction: PropTypes10.oneOf(["ascending", "descending", "none"]).isRequired,
  onClick: PropTypes10.func,
  element: PropTypes10.string
};
import * as React12 from "react";
import * as PropTypes11 from "prop-types";
import { TBody } from "@twilio-paste/table";
var DataGridBody = React12.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "DATA_GRID_BODY"
    } = _b,
    props = __objRest(_b, ["element"]);
  return React12.createElement(TBody, __spreadProps(__spreadValues({}, props), {
    element,
    ref
  }));
});
DataGridBody.displayName = "DataGridBody";
DataGridBody.propTypes = {
  element: PropTypes11.string
};
import * as React13 from "react";
import * as PropTypes12 from "prop-types";
import { TFoot } from "@twilio-paste/table";
var DataGridFoot = React13.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "DATA_GRID_FOOT"
    } = _b,
    props = __objRest(_b, ["element"]);
  return React13.createElement(TFoot, __spreadProps(__spreadValues({}, props), {
    element,
    ref
  }));
});
DataGridFoot.displayName = "DataGridFoot";
DataGridFoot.propTypes = {
  element: PropTypes12.string
};
export { DataGrid, DataGridBody, DataGridCell, DataGridFoot, DataGridHead, DataGridHeader, DataGridHeaderSort, DataGridRow };